var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPerformanceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3044_1429)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 15.215V17.215H4.375V15.215H2ZM0.75 13.215C0.335786 13.215 0 13.5508 0 13.965V18.465C0 18.8792 0.335786 19.215 0.75 19.215H5.625C6.03921 19.215 6.375 18.8792 6.375 18.465V13.965C6.375 13.5508 6.03921 13.215 5.625 13.215H0.75Z",
    fill: "#6C74B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.625 8.84V17.215H13V8.84H10.625ZM9.375 6.84C8.96079 6.84 8.625 7.17578 8.625 7.59V18.465C8.625 18.8792 8.96079 19.215 9.375 19.215H14.25C14.6642 19.215 15 18.8792 15 18.465V7.59C15 7.17578 14.6642 6.84 14.25 6.84H9.375Z",
    fill: "#6C74B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.25 2.84V17.215H21.625V2.84H19.25ZM18 0.839996C17.5858 0.839996 17.25 1.17578 17.25 1.59V18.465C17.25 18.8792 17.5858 19.215 18 19.215H22.875C23.2892 19.215 23.625 18.8792 23.625 18.465V1.59C23.625 1.17578 23.2892 0.839996 22.875 0.839996H18Z",
    fill: "#6C74B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.25 22.715C-0.25 22.1627 0.197715 21.715 0.75 21.715L22.875 21.715C23.4273 21.715 23.875 22.1627 23.875 22.715C23.875 23.2673 23.4273 23.715 22.875 23.715L0.75 23.715C0.197715 23.715 -0.25 23.2673 -0.25 22.715Z",
    fill: "#6C74B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3044_1429"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformanceIcon);
export default __webpack_public_path__ + "static/media/performance-icon.1afc266b88a0d2c49b1361bb06cfb14b.svg";
export { ForwardRef as ReactComponent };